import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Category } from "../state/types"

export const useCategoryActions = () => {
    const saveActions = useSaveActions()

    const saveCategory = (category: Category) => {
        const { save } = saveActions()
        return save(TableName.CATEGORIES, category) as Promise<Category>
    }

    const removeCategory = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.CATEGORIES, id)
    }

    return {
        saveCategory,
        removeCategory
    }
}
